import { h } from "preact";
const ActionButton = ({
  onClick,
  loading,
  disabled,
  children,
  style,
  classNames,
  dataCY = "default"
}) => {
  style = style
    ? style
    : {
        float: "right"
      };
  classNames = classNames ? classNames : "btn-primary btn-lg";
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      class={
        loading
          ? `btn btn-primary btn-lg ${classNames} loading`
          : `btn btn-primary btn-lg ${classNames}`
      }
      style={style}
      data-cy={dataCY}
    >
      {children}
    </button>
  );
};
export default ActionButton;
